import React, { useState } from "react";
import NameIcon from "../../../../svgs/building.svg";
import CodeIcon from "../../../../svgs/supplier-code.svg";
import POCIcon from "../../../../svgs/supplier-poc.svg";
import ContactIcon from "../../../../svgs/supplier-number.svg";
import AddressIcon from "../../../../svgs/supplier-address.svg";
import FormField from "../../../../../Shared/Form/FormField";

const SupplierDetailsModal = ({ onClose, supplier, onDeactivate }) => {
  const [isDeactivating, setIsDeactivating] = useState(false);

  if (!supplier) return null;

  const handleDeactivate = async () => {
    setIsDeactivating(true);
    try {
      await onDeactivate(supplier.id);
      onClose();
    } catch (error) {
      console.error("Error deactivating supplier:", error);
    } finally {
      setIsDeactivating(false);
    }
  };

  return (
    <div className="inventory-modal-overlay" onClick={onClose}>
      <form
        className="inventory-modal supplier-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="inventory-modal-header">
          <h3>Supplier Details</h3>
          <button className="close-btn" type="button" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="inventory-modal-body">
          <FormField
            id="supplier-name"
            name="name"
            title="Supplier Name"
            type="text"
            icon={NameIcon}
            value={supplier.name || ""}
            readOnly
          />
          <FormField
            id="supplier-code"
            name="code"
            title="Supplier Code"
            type="text"
            icon={CodeIcon}
            value={supplier.code || ""}
            readOnly
          />
          <FormField
            id="supplier-poc"
            name="poc"
            title="Supplier POC"
            type="text"
            icon={POCIcon}
            value={supplier.poc_name || ""}
            readOnly
          />
          <FormField
            id="supplier-poc-contact"
            name="pocContact"
            title="Supplier POC Contact Number"
            type="text"
            icon={ContactIcon}
            value={supplier.contact_number || ""}
            readOnly
          />
          <FormField
            id="supplier-address"
            name="address"
            title="Supplier Address"
            type="text"
            icon={AddressIcon}
            value={supplier.address || ""}
            readOnly
          />
          <FormField
            id="supplier-description"
            name="description"
            title="Supplier Description"
            type="textarea"
            value={supplier.description || ""}
            readOnly
          />
        </div>
        <div className="inventory-modal-footer">
          <button
            className="cancel-btn"
            type="button"
            onClick={onClose}
            disabled={isDeactivating}
          >
            Close
          </button>
          {supplier.is_active && (
            <button
              className="submit-btn"
              type="button"
              onClick={handleDeactivate}
              disabled={isDeactivating}
            >
              {isDeactivating ? (
                <>
                  <div className="upload-loader-small"></div>
                  Deactivating...
                </>
              ) : (
                "Deactivate"
              )}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default SupplierDetailsModal;
